function loadView(view) {
    return () => import( /* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`)
}
const defaultRoute = [
    {
      path: '/login',
      name: 'Login',
      meta: {
          requiresAuth: false,
          beforelogin: true,
          roleVerif: false,
          role: []
      },
      component: loadView('Login')
    },
    {
      path: '/lupa-password',
      name: 'Forget Password',
      meta: {
          requiresAuth: false,
          beforelogin: true,
          roleVerif: false,
          role: []
      },
      component: loadView('ForgetPassword')
    },
    {
      path: '/registration',
      name: 'Registration',
      meta: {
          requiresAuth: false,
          beforelogin: true,
          roleVerif: false,
          role: []
      },
      component: loadView('Registration')
    },
    {
      path: '/email-verification/:emailToken',
      name: 'emailVerification',
      meta: {
          requiresAuth: false,
          roleVerif: false,
          role: []
      },
      component: loadView('EmailVerification')
    },
    {
      path: '/forget-password/:token/:id',
      name: 'forgetPasswordVerification',
      meta: {
          requiresAuth: false,
          roleVerif: false,
          role: []
      },
      component: loadView('ForgetPasswordVerification')
    },
    {
      path: '/new-account/:token/:id',
      name: 'new account',
      meta: {
          requiresAuth: false,
          roleVerif: false,
          role: []
      },
      component: loadView('ForgetPasswordVerification')
    },
    {
      path: '/logout',
      name: 'Logout',
      meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
      },
      component: loadView('Logout')
    },
    {
      path: '/temp',
      name: 'temp',
      meta: {
          requiresAuth: false,
          roleVerif: false,
          role: []
      },
      component: loadView('Temp')
    },

]

export default defaultRoute